import { Card, CardContent } from "@/components/ui/card";
import { TASK_CATEGORIES, TaskCategoryType } from "@/lib/taskCategoryConfig";
import { cn } from "@/lib/utils";

interface CategorySelectorProps {
  selectedCategory: TaskCategoryType | null;
  onSelect: (category: TaskCategoryType) => void;
  taskCounts?: Record<string, number>;
}

export const CategorySelector = ({ selectedCategory, onSelect, taskCounts = {} }: CategorySelectorProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {TASK_CATEGORIES.map((category) => {
        const Icon = category.icon;
        const count = taskCounts[category.id] || 0;
        const isSelected = selectedCategory === category.id;
        
        return (
          <Card
            key={category.id}
            className={cn(
              "cursor-pointer transition-all hover:shadow-md",
              isSelected && "ring-2 ring-primary shadow-md"
            )}
            onClick={() => onSelect(category.id)}
          >
            <CardContent className="p-6 flex flex-col items-center text-center space-y-2">
              <div className={cn("p-3 rounded-full", category.bgColor)}>
                <Icon className={cn("h-6 w-6", category.color)} />
              </div>
              <div>
                <h3 className="font-semibold text-sm">{category.name}</h3>
                {count > 0 && (
                  <p className="text-xs text-muted-foreground mt-1">
                    {count} active {count === 1 ? 'task' : 'tasks'}
                  </p>
                )}
              </div>
              <p className="text-xs text-muted-foreground line-clamp-2">
                {category.description}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};